/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RichiesteTimbratureApprovazioniDTO
 */
export interface RichiesteTimbratureApprovazioniDTO {
    /**
     * 
     * @type {number}
     * @memberof RichiesteTimbratureApprovazioniDTO
     */
    idPersonale?: number;
    /**
     * 
     * @type {Date}
     * @memberof RichiesteTimbratureApprovazioniDTO
     */
    data?: Date;
    /**
     * 
     * @type {string}
     * @memberof RichiesteTimbratureApprovazioniDTO
     */
    personale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteTimbratureApprovazioniDTO
     */
    motivazione?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RichiesteTimbratureApprovazioniDTO
     */
    note?: string | null;
    /**
     * 
     * @type {Array<Date>}
     * @memberof RichiesteTimbratureApprovazioniDTO
     */
    entrate?: Array<Date> | null;
    /**
     * 
     * @type {Array<Date>}
     * @memberof RichiesteTimbratureApprovazioniDTO
     */
    uscite?: Array<Date> | null;
}

/**
 * Check if a given object implements the RichiesteTimbratureApprovazioniDTO interface.
 */
export function instanceOfRichiesteTimbratureApprovazioniDTO(value: object): value is RichiesteTimbratureApprovazioniDTO {
    return true;
}

export function RichiesteTimbratureApprovazioniDTOFromJSON(json: any): RichiesteTimbratureApprovazioniDTO {
    return RichiesteTimbratureApprovazioniDTOFromJSONTyped(json, false);
}

export function RichiesteTimbratureApprovazioniDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RichiesteTimbratureApprovazioniDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idPersonale': json['idPersonale'] == null ? undefined : json['idPersonale'],
        'data': json['data'] == null ? undefined : (new Date(json['data'])),
        'personale': json['personale'] == null ? undefined : json['personale'],
        'motivazione': json['motivazione'] == null ? undefined : json['motivazione'],
        'note': json['note'] == null ? undefined : json['note'],
        'entrate': json['entrate'] == null ? undefined : json['entrate'],
        'uscite': json['uscite'] == null ? undefined : json['uscite'],
    };
}

export function RichiesteTimbratureApprovazioniDTOToJSON(json: any): RichiesteTimbratureApprovazioniDTO {
    return RichiesteTimbratureApprovazioniDTOToJSONTyped(json, false);
}

export function RichiesteTimbratureApprovazioniDTOToJSONTyped(value?: RichiesteTimbratureApprovazioniDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idPersonale': value['idPersonale'],
        'data': value['data'] == null ? undefined : ((value['data']).toISOString()),
        'personale': value['personale'],
        'motivazione': value['motivazione'],
        'note': value['note'],
        'entrate': value['entrate'],
        'uscite': value['uscite'],
    };
}

